<template>
    <div>
      <photo-verify @on-success="verifySuccess"></photo-verify>
    </div>
   </template>
   
   <script>
   import PhotoVerify from '@/components/PhotoVerify'
   
   export default {
     name: 'quiet',
     components: {
       PhotoVerify
     },
     methods: {
       verifySuccess(data) {
        this.$router.push('/')
       }
     }
   }
   </script>
   
   <style scoped lang="less">
   .list {
     padding: 50px 30px;
     &-item {
       text-align: center;
       line-height: 40px;
       font-size: 14px;
       background-color: #2b6814;
       color: #fff;
       cursor: pointer;
       & + .list-item {
         margin-top: 30px;
       }
     }
   }
   </style>
   